import { useBetslipContext } from '~/providers/betslip-context';

import type IBet from '../interfaces/IBet';
import styles from '../style/multi-betslip.module.css';

import BetslipBet from './bet';
import BookieSelection from './bookie-selection';
import BookieSelector from './bookie-selector';

const MultiBetslip = (): JSX.Element => {
  const { betslip: bets, bookieOdds, selectedBookie } = useBetslipContext();

  const renderBets = () => {
    return bets.
    map((bet) => {
      const disabled = selectedBookie && !selectedBookie.betIds?.includes(bet.betId);
      return <BetslipBet bet={bet as IBet} disabled={!!disabled} key={bet.betId} />;
    }).
    sort((a, b) => a.props.disabled - b.props.disabled);
  };

  const renderSelector = () => {
    if (bookieOdds.length > 1) return <BookieSelector />;
  };

  return (
    <div className={styles.multiBetslipWrapper}>
      <div className={styles.selectedBookie}>
        <div className={styles.bookie}>
          <BookieSelection selected selectedBookie={selectedBookie!} />
        </div>
      </div>

      <div className={styles.scrollWrapper}>
        {renderBets()}
        {renderSelector()}
      </div>
    </div>);

};

export default MultiBetslip;